import {RouteComponentProps} from '@reach/router';
import React from 'react';
import PageTitle from '../../Components/PageTitle/PageTitle';
import {LMessages} from '../../Localization/Localization';
import {ForgotPasswordForm} from './ForgotPasswordForm';

/**
 * Forgot password page.
 * @param {RouteComponentProps} props
 * @returns {JSX.Element}
 * @constructor
 */
export default function ForgotPasswordCard({}: RouteComponentProps) {
  return (
    <React.Fragment>
      <PageTitle title={LMessages.FORGOT_PASSWORD_TITLE}/>
      <ForgotPasswordForm/>
    </React.Fragment>
  );
}

